import { render, staticRenderFns } from "./DashboardNavigator.vue?vue&type=template&id=6d5ae82a&scoped=true"
import script from "./DashboardNavigator.vue?vue&type=script&lang=js"
export * from "./DashboardNavigator.vue?vue&type=script&lang=js"
import style0 from "./DashboardNavigator.vue?vue&type=style&index=0&id=6d5ae82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ae82a",
  null
  
)

export default component.exports